import * as Yup from 'yup';

export const formSchema = [
  {
    name: 'amount',
    validate: Yup.number().typeError('Số điểm không hợp lệ'),
  },
];
